export const doesUrlContainJavascript = (url: string) => {
    return Boolean(url && url.toLowerCase().startsWith('javascript'));
};
